module.exports = __webpack_public_path__ + "img/filter.aa2cce35.svg";